<template>
  <div>
    <div class="container px-6 mt-16">
      <h1 class="text-lg pl-0 md:pl-6 font-bold"><span class="text-pink-500">5.</span>
        {{ $t('messages.step_five.title') }}
      </h1>
      <p class="mt-4 px-0 md:px-6 font-semibold">
        {{ $t('messages.step_five.description') }}
      </p>
      <div class="w-full ">
        <div
          v-for="(item, index) in filtered_question"
          :key="index"
        >
          <div
            class="flex mt-6 flex-wrap"
            v-for="(data, id) in item.subcategories"
            :key="id"
          >
            <h1 class="w-full uppercase text-lg text-blue-500 font-bold mt-6 pl-0 md:pl-6">{{data.name[locale]}}</h1>
            <div class="text-blue-500 pl-6 mb-4" v-if="['about-your-personality', 'lifestyle-couple'].includes(data.key)">{{ $t('messages.step_five.ideal_couple_legend') }}</div>
            <template v-for="(question) in data.questions">
              <question
                :question="question.title"
                :typeQuestion="question.type_question"
                :placeholder="question.placeholder"
                :questionOption="question.options"
                :vvScope="vvScope"
                :validations="{ required: question.required === 1 }"
                :block="question.validate_text"
                :name="question.title"
                :width="question.width"
                :key="question.id"
                :id="question.id"
                :meta="data.key"
                :indication="question.indication"
              >
              </question>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Question from "@/components/Question.vue";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";
import { sameAs, minLength } from "vuelidate/lib/validators";
import { mapState, mapActions } from "vuex";

export default {
  name: "RegisterStepFive",
  props: ["clickedNext", "currentStep"],
  mixins: [validationMixin],
  components: {
    Question
  },
  data() {
    return {
      vvScope: "step5",
      filtered_question: [],
      genre: "Hombre",
      options_genre: [
        { text: "Mujer", value: "Hombre" },
        { text: "Hombre", value: "Mujer" }
      ],
      range_slide: {
        range_age: [18, 100]
      },
      form: {
        language: ""
      },
      value: [
        {
          name: "El Salvador",
          code: "js"
        }
      ],
      options: [
        { name: "Colombia", code: "vu" },
        { name: "Costa Rica", code: "js" },
        { name: "Mexico", code: "os" }
      ]
    };
  },
  computed: {
    ...mapState("questions", ["questions"]),
    ...mapState("locale", ["locale"])
  },
  async created() {
    await this.getQuestions();
    await this.showQuestion();
  },
  methods: {
    ...mapActions("questions", ["getQuestions"]),
    showQuestion() {
      this.filtered_question = this.questions.filter(
        question => question.key === "ideal-couple"
      );
    }
  }
};
</script>
<style lang="scss">
.steps-wrapper {
  .step {
    .circle {
      i[data-v-3ee86246] {
        background-color: #f35a78 !important;
      }
    }
  }
}
</style>
